export const MENU_BUTTON_CLASSES = [
  'px-3',
  'py-1.5',
  'text-black',
  'dark:text-white',
  'dark:hover:bg-darkMode-gray-hover',
  'flex-shrink-0',
  '[&>svg]:w-6',
  '[&>svg]:h-6',
  '[&>svg]:flex-shrink-0'
];

export const HAIRLINE_DIVIDER_CLASSES = [
  'w-full',
  'h-0.5',
  'rounded',
  'flex-shrink-0',
  'bg-lightMode-gray-light-hover',
  'dark:bg-darkMode-gray-hover'
];
